import { createContext, type ReactNode, useContext } from 'react';
import { type EventsSocket, useEventsSocket } from './use-events-socket';

interface LiveSocket {
  socket: EventsSocket | null;
  connected: boolean;
}

const LiveSocketContext = createContext<LiveSocket>({ socket: null, connected: false });

/**
 * One WebSocket for the whole signed-in website (the layout holds it): every page listens on it, and
 * the top bar shows whether live updates are coming in.
 */
export function LiveSocketProvider({ enabled, children }: { enabled: boolean; children: ReactNode }) {
  const live = useEventsSocket(enabled);
  return <LiveSocketContext value={live}>{children}</LiveSocketContext>;
}

/** The shared WebSocket (null while signed out) and whether it is connected. */
export function useLiveSocket(): LiveSocket {
  return useContext(LiveSocketContext);
}
